import { createSlice } from '@reduxjs/toolkit'

import { SettingType } from './setting.type'

const initialState: SettingType = {
  menu: false,
  spaceActive: null,
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setMenu: (state, action) => {
      state.menu = action.payload
    },
    setActiveSpace: (state, action) => {
      state.spaceActive = action.payload
    },
  },
  extraReducers: () => {},
})

export const settingsActions = settingsSlice.actions
const settingsReducer = settingsSlice.reducer
export default settingsReducer
